import { render } from "./WorkCards.vue?vue&type=template&id=bab8afcc&scoped=true"
import script from "./WorkCards.vue?vue&type=script&lang=js"
export * from "./WorkCards.vue?vue&type=script&lang=js"

import "./WorkCards.vue?vue&type=style&index=0&id=bab8afcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bab8afcc"]])

export default __exports__